import React from 'react';
import { connect } from 'react-redux';

import MenuItemChoiceSelection from '../../common/menuitem/MenuItemChoiceSelection';
import SpecialItemInformation from './SpecialItemInformation';
import SpecialItemInstructions from './SpecialItemInstructions';
import SpecialItemSubmitButton from './SpecialItemSubmitButton';

import { cartItemLoadSpecialItems } from '../../../actions/cartItem';
import generateSpecialPrice from '../../../utils/generateSpecialPrice';
import getSpecialCustomToppingDetails from '../../../selectors/specialCustomToppingDetails';

import { setSpecialPanel } from '../../../actions/panels';

class ViewCustomPizza extends React.Component {

    updateSpecialItems(curSpecialItem) {
        let curSpecial = this.props.cartItem;

        // update the specific item
        curSpecial.items[this.props.index] = curSpecialItem;
        this.props.dispatch(cartItemLoadSpecialItems(curSpecial.items));
    }

    printCrustName(cid) {

        for (let i = 0; i < this.props.specialPizza.crusts.length; i++) {
            if (this.props.specialPizza.crusts[i].id == cid) {
                let theCrustName = this.props.specialPizza.crusts[i].name;
                if (parseFloat(this.props.specialPizza.crusts[i].price) > 0) {
                    theCrustName += " - "+this.props.specialPizza.crusts[i].price;
                }
                return theCrustName;
            }
        }
    }

    printSauceName(sid) {
        for (let i = 0; i < this.props.specialPizza.sauces.length; i++) {
            if (this.props.specialPizza.sauces[i].id == sid) {
                let theSauceName = this.props.specialPizza.sauces[i].name;
                if (parseFloat(this.props.specialPizza.sauces[i].price) > 0) {
                    theSauceName += " - "+this.props.specialPizza.sauces[i].price;
                }
                return theSauceName;
            }
        }
    }

    renderSpecialCustomPizzaChoices() {

        return (
            <div>
                <div className="selectionTitleText">
                    <p>How do you want it?</p>
                </div>

                <MenuItemChoiceSelection
                    key='toppings'
                    onChoicePress={() => this.props.dispatch(setSpecialPanel('custom_pizza_toppings'))}
                    selectionText={getSpecialCustomToppingDetails(this.props.cartItem, this.props.special, this.props.index)}
                >
                    Toppings
                </MenuItemChoiceSelection>

                {(this.props.specialPizza.crusts.length > 1) && (<MenuItemChoiceSelection
                    key='crusts'
                    onChoicePress={() => this.props.dispatch(setSpecialPanel('custom_pizza_crusts'))}
                    selectionText={this.printCrustName(this.props.cartItem.items[this.props.index].crust_id)}
                >
                    Crust
                </MenuItemChoiceSelection>)}

                {(this.props.specialPizza.sauces.length > 1) && (<MenuItemChoiceSelection
                    key='sauces'
                    onChoicePress={() => this.props.dispatch(setSpecialPanel('custom_pizza_sauces'))}
                    selectionText={this.printSauceName(this.props.cartItem.items[this.props.index].sauce_id)}
                >
                    Sauce
                </MenuItemChoiceSelection>)}
                
            </div>
        );
    }

    render() {

        return (
            <div>
                <div className="menu-item-window">
                
                    <SpecialItemInformation 
                        type="pizza"
                        item={this.props.specialPizza} 
                    />

                    {this.renderSpecialCustomPizzaChoices()}

                    <SpecialItemInstructions 
                        placeholder="Any special instructions?"
                        value={this.props.cartItem.items[this.props.index].instructions}
                        onChangeText={(e) => {
                            this.updateSpecialItems({
                                ...this.props.cartItem.items[this.props.index],
                                instructions: e.target.value
                            });
                        }}
                    />

                    <p className="disclaimer">
                        Please note: Addons and substitutions requested via special
                        instructions that are subject to extra pricing may not be honoured by the 
                        restaurant.
                    </p>
                </div>

                <div className="fixed-wrapper-for-add-to-order">

                    <SpecialItemSubmitButton
                        onButtonPress={() => this.props.dispatch(setSpecialPanel('info'))}
                        price={generateSpecialPrice(this.props.special, this.props.cartItem)}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        cartItem: state.cartItem,
        special: state.currentMenuItem.item
    };
};

export default connect(mapStateToProps)(ViewCustomPizza);
